<template>
  <div>
    <el-card class="filter-box-card"
             shadow="nerver">
      <!-- 选日期 -->
      <div style="margin-bottom: 10px">
        下单日期：
        <el-date-picker size="mini"
                        v-model="selectMakeBookingDateRange"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd"
                        :default-time="['00:00:00', '23:59:59']">
        </el-date-picker>
      </div>
      <div style="margin-bottom: 10px">
        参加日期：
        <el-date-picker size="mini"
                        v-model="selectTripDateRange"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd"
                        :default-time="['00:00:00', '23:59:59']">
        </el-date-picker>
      </div>
      <!-- 服务商 -->
      <div>
        选择服务商：
        <el-select size="mini"
                   clearable
                   v-model="selectOperator"
                   placeholder="请选择"
                   @visible-change="openSelectOperator"
                   @change="changeOperator">
          <el-option v-for="item in options"
                     :key="item.operator_id"
                     :label="item.operator_name"
                     :value="item.operator_id">
          </el-option>
        </el-select>
      </div>
      <!-- 选择uid -->
      <div style="margin-top: 10px">
        下单id：
        <el-input v-model="uid"
                  style="width:15%"
                  size="mini"
                  placeholder="下单id"></el-input>

      </div>
      <!-- 搜索按钮 -->
      <div style="margin-top: 20px">
        <el-button size="mini"
                   @click="testBookingBill">隐藏</el-button>
        <el-button size="mini"
                   @click="searcBookingBill">搜索</el-button>
      </div>
    </el-card>
    <!-- 非管管理员 -->
    <el-card v-if="is_staff"
             shadow="nerver">
      <div style="width:auto;text-align:center;"> 请联系管理员获取权限</div>

    </el-card>
    <!-- 统计列表 -->
    <el-card v-else
             class="content-box-card"
             shadow="nerver">
      <!-- 数据汇总 -->
      <div class="show_data_deal_with_all"
           v-if="sell_price_total != 0">
        <div>订单数：{{ num_booking }}</div>
        <div>销售额：{{ (sell_price_total / 100).toFixed(2) }}</div>
        <div>成本：{{ (net_price_total / 100).toFixed(2) }}</div>
        <div>利润：{{ (commission / 100).toFixed(2) }}</div>
        <div>总数量：{{ num_sku }}</div>
      </div>

      <!-- 列表 -->
      <el-table style="font-size: 13px; width: 100%"
                :data="tableBillData"
                border
                :stripe="false">
        <!-- 订单来源 -->
        <el-table-column :show-overflow-tooltip="true"
                         label="售价"
                         width="auto">
          <template slot-scope="product">
            {{ product.row.ota_source }} {{ product.row.id }}
          </template>
        </el-table-column>
        <!-- 平台单号 -->
        <el-table-column label="单号"
                         width="160">
          <template slot-scope="product">
            <div>
              <div>{{ product.row.ota_id }}</div>
            </div>
            <!-- <div>系统单号：{{ product.row.id }}</div> -->
          </template>
        </el-table-column>
        <el-table-column prop="contact"
                         label="联系人"
                         width="70"></el-table-column>
        <el-table-column :show-overflow-tooltip="true"
                         label="产品名称"
                         width="250">
          <template slot-scope="product">
            <!-- <div>{{ product.row.spu_name }}</div> -->
            <div>
              {{ product.row.sku_name }}
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="price_type"
                         label="规格"
                         width="60"></el-table-column>
        <el-table-column prop="num"
                         label="数量"
                         width="50"></el-table-column>
        <!-- <el-table-column label="底价" width="auto">
          <template slot-scope="product">
            {{ (product.row.net_price / 100).toFixed(2) }}
          </template></el-table-column
        > -->
        <el-table-column label="底价合计"
                         width="auto">
          <template slot-scope="product">
            <!-- <i :title="'底价:' + (product.row.net_price / 100).toFixed(2)">
              {{ (product.row.net_prices / 100).toFixed(2) }}</i
            > -->
            <el-popover @hide="hidePopver"
                        trigger="click"
                        placement="top"
                        width="200">
              <p>
                当前套餐底价为：
                {{ (product.row.net_price / 100).toFixed(2) }}
              </p>
              <el-button v-if="showInputChangeNetPrice"
                         size="mini"
                         type="text"
                         @click="changeBookingDetialNetPrice(product.row)">修改底价</el-button>
              <div style="margin-top: 10px; dispay: inline"
                   v-else>
                <el-input v-model="newNetPrice"
                          style="width: 100px; margin-right: 10px"
                          size="mini">输入框</el-input>
                <el-button size="mini"
                           type="text"
                           @click="showInputChangeNetPrice = true">取消</el-button>
                <el-button type="text"
                           size="mini"
                           @click="submitNetPrice(product.row)">确定</el-button>
              </div>
              <!-- 外部按钮 -->
              <el-button size="mini"
                         type="text"
                         slot="reference">
                {{ (product.row.net_prices / 100).toFixed(2) }}
              </el-button>
            </el-popover>
          </template>
        </el-table-column>
        <!-- <el-table-column label="售价" width="auto">
          <template slot-scope="product">
            {{ (product.row.sell_price / 100).toFixed(2) }}
          </template></el-table-column
        > -->
        <el-table-column label="实际成交价"
                         width="auto">
          <!-- <template slot-scope="product">
            {{ (product.row.total_fee / 100).toFixed(2) }}
          </template> -->
          <template slot-scope="product">
            <el-popover @hide="hidePopver"
                        trigger="click"
                        placement="top"
                        width="200">
              <p>
                当前订单总金额：
                {{ (product.row.total_fee / 100).toFixed(2) }}
              </p>
              <el-button v-if="showInputChangeNetPrice"
                         size="mini"
                         type="text"
                         @click="changeBookingDetialNetPrice(product.row)">修改订单金额</el-button>
              <div style="margin-top: 10px; dispay: inline"
                   v-else>
                <el-input v-model="newNetPrice"
                          style="width: 100px; margin-right: 10px"
                          size="mini">输入框</el-input>
                <el-button size="mini"
                           type="text"
                           @click="showInputChangeNetPrice = true">取消</el-button>
                <el-button type="text"
                           size="mini"
                           @click="submitNewPrice(product.row)">确定</el-button>
              </div>
              <!-- 外部按钮 -->
              <el-button size="mini"
                         type="text"
                         slot="reference">
                {{ (product.row.total_fee / 100).toFixed(2) }}
              </el-button>
            </el-popover>
          </template>
        </el-table-column>
        <!-- 服务商 -->
        <el-table-column :show-overflow-tooltip="true"
                         label="服务商"
                         width="130">
          <template slot-scope="product">
            <!-- <div>{{ product.row.spu_name }}</div> -->
            <div>{{ product.row.operator_name }}</div>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

  </div>
</template>

<script>
export default {
  name: 'BookingBill',
  data() {
    return {
      is_staff: true,
      // 筛选区域
      selectTripDateRange: [], // 参加日期
      selectMakeBookingDateRange: [], // 下单日期
      options: [], // 服务商选项
      selectOperator: [], // 选择后的服务商
      uid: '',
      // 列表数据
      tableBillData: [], // 列表
      net_price_total: 0,
      sell_price_total: 0,

      commission: 0,
      num_sku: 0,
      num_booking: 0,
      // 修改底价
      showInputChangeNetPrice: true,
      newNetPrice: undefined,
      // 页码
      pagenum_system: 0,
      pagesize_system: 0,
    }
  },
  created() {
    // 判断张类型是否是员工
    this.$http.get(`/user/get_user_type`).then((res) => {
      if (res.data.type == true) {
        this.is_staff = true
      } else {
        this.is_staff = false
      }
    })
  },
  methods: {
    // 点击底价的时候
    clickThisButton() {
      this.showPopover = true
      console.log(this.showPopover)
    },
    // 打开修改套餐底价
    changeBookingDetialNetPrice() {
      this.showInputChangeNetPrice = false
    },
    // 提交修改套餐底价
    submitNetPrice(item) {
      this.$http
        .get(
          `/statistics/booking_bill/change_net_price?id=${
            item.id
          }&new_net_price=${this.newNetPrice * 100}&type_id=${item.type_id}`
        )
        .then((res) => {
          const { errno, errmsg } = res.data
          if (errno == '0') {
            this.$notify({
              title: '成功',
              message: errmsg,
              type: 'success',
            })
            this.searcBookingBill()
          } else {
            this.$notify({
              title: '警告',
              message: errmsg,
              type: 'warning',
            })
          }
        })
    },
    // 修改订单销售额
    submitNewPrice(item) {
      console.log(item)
      this.$http
        .get(
          `/statistics/booking_bill/change_sale_price?id=${
            item.id
          }&new_sale_price=${this.newNetPrice * 100}&type_id=${item.type_id}`
        )
        .then((res) => {
          const { errno, errmsg } = res.data
          if (errno == '0') {
            this.$notify({
              title: '成功',
              message: errmsg,
              type: 'success',
            })
            this.searcBookingBill()
          } else {
            this.$notify({
              title: '警告',
              message: errmsg,
              type: 'warning',
            })
          }
        })
    },
    // 因藏弹出框
    hidePopver() {
      this.showInputChangeNetPrice = true
      this.newNetPrice = undefined
    },
    // openSelectOperator 搜索服务商
    openSelectOperator() {
      this.$http.get(`/product/get_operator_list`).then((res) => {
        this.options = res.data.data
      })
    },
    // 选择中服务商
    changeOperator() {},
    // 测试
    testBookingBill() {
      this.$http.get(`/statistics/booking_bill`).then((res) => {})
    },
    // 搜索 账单
    searcBookingBill() {
      this.pagenum_system = 1
      this.pagesize_system = 100
      // 所选服务商
      let op = this.selectOperator
      // 下单人
      let uid = this.uid
      // 下单日期
      if (
        this.selectMakeBookingDateRange == 0 ||
        this.selectMakeBookingDateRange == null
      ) {
        this.selectMakeBookingDateRange = []
      }

      let sd = this.selectMakeBookingDateRange[0]
      if (sd == undefined) {
        sd = ''
      }
      let ed = this.selectMakeBookingDateRange[1]
      if (ed == undefined) {
        ed = ''
      }
      // 活动日期
      if (this.selectTripDateRange == 0 || this.selectTripDateRange == null) {
        this.selectTripDateRange = []
      }

      let std = this.selectTripDateRange[0]
      if (std == undefined) {
        std = ''
      }
      let etd = this.selectTripDateRange[1]
      if (etd == undefined) {
        etd = ''
      }
      // 发送请求 http://127.0.0.1:5000/statistics/booking_bill?sd=2020-10-01&ed=2020-10-18&page_number=1&page_size=10$std=2020-10-13&etd=2020-10-13
      this.$http
        .get(
          `/statistics/booking_bill?uid=${uid}&op=${op}&scd=${sd}&ecd=${ed}&std=${std}&etd=${etd}&page_number=${this.pagenum_system}&page_size=${this.pagesize_system}`
        )
        .then((res) => {
          console.log(res)
          this.tableBillData = res.data.data
          this.net_price_total = res.data.net_price_total
          this.sell_price_total = res.data.sell_price_total
          this.commission = res.data.commission
          this.num_booking = res.data.num_booking
          this.num_sku = res.data.num_sku
        })
    },
  },
}
</script>

<style>
.filter-box-card {
  height: auto;
  margin-bottom: 5px;
}
.show_data_deal_with_all {
  width: auto;
  padding: 10px;
  margin-bottom: 20px;
  border-radius: 4px;
  background-color: cornsilk;
}
</style>